import { storeToRefs } from 'pinia';
import { computed, ref } from 'vue';
import type { Ref } from 'vue';

import { useEmailSenders } from '@/store';

interface UseHasSharedInboxResult {
  ready: Ref<boolean>;
  value: Ref<boolean>;
}

export function useHasSharedInbox(): UseHasSharedInboxResult {
  const store = useEmailSenders();
  const ready = ref(false);

  store.fetchEmailSenders().finally(() => {
    ready.value = true;
  });

  const { emailSenders } = storeToRefs(store);
  const value = computed(() => emailSenders.value.some((s) => s.is_shared));

  return { ready, value };
}
